import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useQuery } from 'react-query';

function usePodcastSubscription(data = {}) {
  const { enabled = false, subscriptionId } = data;
  const { privateFetch } = useContext(FetchContext);

  const getSubscription = () =>
    privateFetch.get(`/v1/admin/podcast-billing/subscriptions/${subscriptionId}`);

  return useQuery(['podcast-subscription-detail', subscriptionId], getSubscription, {
    enabled: enabled && !!subscriptionId,
    keepPreviousData: false,
  });
}

export default usePodcastSubscription;
